<template>
	<section>

		<!--Cabinet Wrap-->
		<section class="cabinet section_pad">
			<div class="row">
				<div class="layout">

					<!--Sidebar-->
					<aside class="sidebar layout__sidebar">

						<!--Sidebar Avatar-->
						<div class="sidebar__avatar-wrap">
							<user-avatar :data="user" :setClass="'sidebar__avatar user_fix'"></user-avatar>
						</div>
						<!--Sidebar Avatar End-->

						<!--Sidebar Menu-->
						<nav class="sidebar__menu">
							<ul class="sidebar__list">
								<!--<li class="sidebar__list-item">
									<a class="sidebar__link" v-if="isDoctor"> - Моя страница</a>
								</li>-->

								<!--<li class="sidebar__list-item">
									<a href="#" class="sidebar__link"> - Мои новости</a>
								</li>-->

								<li class="sidebar__list-item">
									<router-link :to="{name: 'Events'}" class="sidebar__link"> - Мои события</router-link>
								</li>

								<!--<li class="sidebar__list-item">
									<a href="#" class="sidebar__link"> - Мои отзывы</a>
								</li>-->
								<li class="sidebar__list-item">
									<router-link :to="{name: 'Visits'}" class="sidebar__link"> - Визиты</router-link>
								</li>
								<!--<li class="sidebar__list-item">
									<a href="#" class="sidebar__link"> - Избранное</a>
								</li>-->
							</ul>
						</nav>
						<!--Sidebar Menu End-->

					</aside>
					<!--Sidebar End-->

					<!--Cabinet content-->
					<div class="layout__box">
						<router-view></router-view>
					</div>
					<!--Cabinet content-->

				</div>
				<!--Cabinet End-->

			</div>
			<!--Row End-->

		</section>
		<!--Cabinet Wrap-->

	</section>
</template>

<script>
	export default {
		name: "Cabinet",
		computed: {
			isDoctor() {
				return this.$store.state.auth.isDoctor
			},
			user() {
				if(this.$store.state.auth.isDoctor) {
					return this.$store.state.auth.worker
				}

				return this.$store.state.auth.user
			}
		},
		mounted() {
			this.$router.push({name: 'Events'})
		}
	}
</script>



// WEBPACK FOOTER //
// Main.vue?605b88d2